import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "./components/ui/toaster";
import { Toaster as SonnerToaster } from "sonner";
import { ThemeProvider } from "./contexts/ThemeContext";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { Layout } from "./components/layout/Layout";
import { DebugModeProvider } from "./contexts/DebugModeContext";

// Pages
import HomePage from "./pages/HomePage";
import AuthPage from "./pages/AuthPage";
import MyWorkoutsPage from "./pages/MyWorkoutsPage";
import EditWorkoutPage from "./pages/EditWorkoutPage";
import ActiveWorkout from "./pages/activity/workout/ActiveWorkout";
import WorkoutHistoryPage from "./pages/WorkoutHistoryPage";
import ActivityLogPage from "./pages/ActivityLogPage";
import SettingsPage from "./pages/SettingsPage";

// Create a client for React Query
const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider>
      <DebugModeProvider>
        <QueryClientProvider client={queryClient}>
          <Router>
            <Routes>
              <Route element={<ProtectedRoute />}>
                {/* Dashboard (authenticated home) */}
                <Route
                  path="/"
                  element={
                    <Layout>
                      <MyWorkoutsPage />
                    </Layout>
                  }
                />

                {/* Other routes with Layout */}
                <Route path="/workout/edit/:id" element={<EditWorkoutPage />} />
                <Route
                  path="/workout-history"
                  element={
                    <Layout>
                      <WorkoutHistoryPage />
                    </Layout>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <Layout>
                      <SettingsPage />
                    </Layout>
                  }
                />

                <Route path="/workout/start/:id" element={<ActiveWorkout />} />
                <Route path="/activity/:id" element={<ActivityLogPage />} />
              </Route>
              <Route path="/landing" element={<HomePage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="*" element={<Navigate to="/landing" replace />} />
            </Routes>
          </Router>
          <Toaster />
          <SonnerToaster position="top-right" />
        </QueryClientProvider>
      </DebugModeProvider>
    </ThemeProvider>
  );
}

export default App;
